import { Platform } from "react-native";

import {
  ANONYMOUS_KEY_COOKIE,
  ANONYMOUS_KEY_MAX_AGE_SECONDS,
} from "@medbillai/utils/flag";

/**
 * The one anonymous key — server and browser share this cookie, so the SDK
 * never mints a diverging one. Native has no server render and keeps the
 * SDK's key.
 */
export const anonymousLdKey = (): string | undefined => {
  if (Platform.OS !== "web" || typeof document === "undefined") {
    return undefined;
  }
  const existing = document.cookie
    .split("; ")
    .find(entry => entry.startsWith(`${ANONYMOUS_KEY_COOKIE}=`))
    ?.slice(ANONYMOUS_KEY_COOKIE.length + 1);
  if (existing) {
    return existing;
  }
  // `randomUUID` is absent on insecure non-localhost origins; the SDK mints
  // its own there.
  const minted = window.crypto?.randomUUID?.();
  if (!minted) {
    return undefined;
  }
  // No `Secure`: an http dev origin would silently drop the write, and the
  // key is a random bucketing id, not a credential.
  // biome-ignore lint/suspicious/noDocumentCookie: the Cookie Store API is async and unsupported in Safari; this must be readable synchronously on first render
  document.cookie = `${ANONYMOUS_KEY_COOKIE}=${minted}; Path=/; Max-Age=${ANONYMOUS_KEY_MAX_AGE_SECONDS}; SameSite=Lax`;
  return minted;
};
